//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
SPLM.GeometricUtilities.Dummy = Object.freeze({
    "Line" : "Line"});

SPLM.GeometricUtilities.CurveType = Object.freeze({
    "Rubber" : "Rubber", "Line" : "Line", "Circle" : "Circle", "Ellipse" : "Ellipse", "Intersection" : "Intersection", "Spline" : "Spline", "SpCurve" : "SpCurve", "Foreign" : "Foreign", "ConstantParameter" : "ConstantParameter", "TrimmedCurve" : "TrimmedCurve", "Undefined" : "Undefined"});

SPLM.GeometricUtilities.SurfaceType = Object.freeze({
    "Rubber" : "Rubber", "Planar" : "Planar", "Cylindrical" : "Cylindrical", "Conical" : "Conical", "Spherical" : "Spherical", "Toroidal" : "Toroidal", "Parametric" : "Parametric", "Blending" : "Blending", "Offset" : "Offset", "Swept" : "Swept", "Convergent" : "Convergent", "Undefined" : "Undefined"});

SPLM.GeometricUtilities.BodyType = Object.freeze({
    "Solid" : "Solid", "Sheet" : "Sheet", "Minimum" : "Minimum", "Wire" : "Wire", "General" : "General", "Acorn" : "Acorn", "Undefined" : "Undefined"});

export default SPLM;